// extracted by mini-css-extract-plugin
export var bodySections = "_4e-8";
export var gray = "_4e-7";
export var green = "_4e-4";
export var iconContainer = "_4e-9";
export var iconWidgetContainer = "_4e-1";
export var phoneIcon = "_4e-2";
export var red = "_4e-5";
export var statusDot = "_4e-3";
export var widgetContainer = "_4e-0";
export var yellow = "_4e-6";